import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import { withStyles } from '@material-ui/core/styles';
import AttachFile from '@material-ui/icons/AttachFile';
import React from 'react';

// import axios, { post } from 'axios';
const styles = theme => ({
    input: {
      display: 'none',
    },
    buttonRoot: {
      boxShadow: 'none'
    }
  });

class FileUploader extends React.Component {
    

    onChange = e => {
        const fileList = this.props.files.concat(e.target.files[0])
        this.props.setFile(fileList)
    }

    // fileUpload = file => {
    //     const url = 'http://example.com/file-upload';
    //     const formData = new FormData();
    //     formData.append('file',file)
    //     const config = {
    //         headers: {
    //             'content-type': 'multipart/form-data'
    //         }
    //     }
    //     return post(url, formData,config)
    // }


    renderChips() {
        return (
            this.props.files.map (file => {
                return (
                    <Chip
                        key={file.name}
                        label={file.name}
                        onDelete={this.handleDelete(file.name)}
                        // className={classes.chip}
                        color="primary"
                        variant="outlined"
                    />
                )
            })
        )
    }

    render() {
        console.log("render call")
        const { classes } = this.props;
        return (
            <div>
                <input className={classes.input} onChange={this.onChange} type="file" id="attach-file-button" />
                <label htmlFor="attach-file-button">
                    <Fab className={classes.buttonRoot} arial-label="Attach file" size="small" component="span">
                        <AttachFile/>
                    </Fab>
                </label>
            </div>
        )
    }
}

export default withStyles(styles)(FileUploader)